import { createSlice } from "@reduxjs/toolkit";
import {
    createMeetingRequest,
    getMeetingRequests,
    checkAvailabilityForSlot
} from './thunk';

export const initialState = {
    meetingRequests: [],
    availabilityCheck: null,
    errors: {},
    loading: false
};

const MeetingRequestSlice = createSlice({
    name: 'MeetingRequest',
    initialState,
    reducers: {
        clearMeetingRequestState: (state: any) => {
            state.meetingRequests = [];
            state.availabilityCheck = null;
            state.errors = {};
        }
    },
    extraReducers: (builder) => {
        builder.addCase(createMeetingRequest.pending, (state: any) => {
            state.loading = true;
            state.errors = {};
        });
        builder.addCase(createMeetingRequest.fulfilled, (state: any, action: any) => {
            state.loading = false;
            if (action.payload) {
                state.meetingRequests.unshift(action.payload);
            }
            state.errors = {};
        });
        builder.addCase(createMeetingRequest.rejected, (state: any, action: any) => {
            state.loading = false;
            state.errors = { message: action.error?.message || 'Failed to create meeting request' };
        });

        builder.addCase(getMeetingRequests.pending, (state: any) => {
            state.loading = true;
        });
        builder.addCase(getMeetingRequests.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.meetingRequests = action.payload || [];
            state.errors = {};
        });
        builder.addCase(getMeetingRequests.rejected, (state: any, action: any) => {
            state.loading = false;
            state.errors = { message: action.error?.message || 'Failed to get meeting requests' };
            state.meetingRequests = [];
        });

        builder.addCase(checkAvailabilityForSlot.pending, (state: any) => {
            state.loading = true;
        });
        builder.addCase(checkAvailabilityForSlot.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.availabilityCheck = action.payload;
            state.errors = {};
        });
        builder.addCase(checkAvailabilityForSlot.rejected, (state: any, action: any) => {
            state.loading = false;
            state.errors = { message: action.error?.message || 'Failed to check availability' };
            state.availabilityCheck = null;
        });
    }
});

export const { clearMeetingRequestState } = MeetingRequestSlice.actions;
export default MeetingRequestSlice.reducer;

